<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line"></div>
        <div class="mypage__page">
          <ul class="mypage__page__ul">
            <li class="mypage__page__li" v-for="(item, index) in researchList" :key="index" @click="$router.push(`/lab/requestResearch?researchNo=${item.researchNo}&subject=${item.subject}`)">
              <p><span class="small">[{{ item.year }}년]</span><br>{{ item.subject }}</p>
              <i data-v-ef50f1be="" class="i_right_gr50"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      researchList: [],
      params: {
        userNo: this.$store.getters['account/getUserData'].userNo
      }
    }
  },
  created: function () {
    this.getLabResearchList()
  },
  methods: {
    getLabResearchList: async function () {
      const res = await this.$LabSvc.getLabResearchList(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.researchList = entity
      }
    }
  }
}
</script>
